import {SectionTitle, Text} from '@/components-v2'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useCallback} from 'react'
import {ComboProductQuantityRow} from './ComboProductQuantityRow'

export const ComboProductQuantity = () => {
  const {
    productCombo: {comboSkus},
    setProductCombo,
  } = useProductCombo()

  const handleUpdateProductQuantity = useCallback(
    (productId, quantity) => {
      setProductCombo(previousProductCombo => ({
        ...previousProductCombo,
        comboSkus: previousProductCombo.comboSkus.map(currentProduct =>
          currentProduct.productId === productId ? {...currentProduct, quantity} : currentProduct
        ),
      }))
    },
    [setProductCombo]
  )

  return (
    <div className="flex flex-col gap-4 rounded-lg bg-[var(--color-background-layer-01)] p-6">
      <SectionTitle label="Product Quantity" />
      <Text size="xsmall">At least 2 products are required. There is no maximum limit.</Text>
      <div className="h-px bg-gray-600" />
      {comboSkus?.map(product => (
        <ComboProductQuantityRow
          key={product.productId}
          product={product}
          onUpdateProductQuantity={handleUpdateProductQuantity}
        />
      ))}
    </div>
  )
}
